import Subpage from "../shared/components/subpage/subpage";
import BgDecoration from "../shared/components/bgDecoration/bgDecoration";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Filters from "../shared/components/filters/filters";
import React from "react";
import Podium from "../shared/components/podium/podium";
import Sharer from "../shared/components/sharer/sharer";
import Container from "@mui/material/Container";
import { dehydrate, QueryClient, useQuery } from "react-query";
import queryKeys from "../shared/api/queryKeys";
import getLeaderboardsFilters from "../shared/api/queries/getLeaderboardsFilters";
import styled from "@emotion/styled";
import breakpoints from "../shared/helpers/breakpoints";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "next-i18next";
import { homepageAnchorIdentifiers } from "../shared/routes";
import NativeAnchor from "../shared/components/nativeAnchor/nativeAnchor";
import Head from "next/head";
import dynamic from "next/dynamic";

const TableLeaderboard = dynamic(
  () => import("../shared/components/tableLeaderboard/tableLeaderboard")
);

export interface FilterGetParams {
  discipline?: string;
  category?: string;
  country?: string;
  club?: string;
  display?: string;
  id?: string;
}

interface LeaderboardsProps {
  query: FilterGetParams;
}

const ContainerInner = styled.div`
  padding: 16px 0;
  @media (min-width: ${breakpoints.min.md}) {
    padding: 32px 0;
  }
`;

const Leaderboards: React.FC<LeaderboardsProps> = ({ query }) => {
  const { t } = useTranslation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Head>
        <title>{t("meta.leaderboards.title")}</title>
        <meta name="description" content={t("meta.leaderboards.description")} />
        <meta property="og:title" content={t("meta.leaderboards.title")} />
        <meta
          property="og:description"
          content={t("meta.leaderboards.description")}
        />
        <meta property="og:image" content="/images/og/default.jpg" />
      </Head>
      <NativeAnchor id={homepageAnchorIdentifiers.leaderboards} />
      <BgDecoration top={true}>
        <BgDecoration top={true}>
          <Subpage>
            <Filters query={query} title={t("leaderboards")} />
            <Container>
              <ContainerInner>
                <Podium query={query} />
                <TableLeaderboard query={query} />
                <Box mt={4} />
                <Grid container>
                  <Grid item xs={12} md={9}></Grid>
                  <Grid item xs={12} md={3}>
                    <Sharer />
                  </Grid>
                </Grid>
              </ContainerInner>
            </Container>
          </Subpage>
        </BgDecoration>
      </BgDecoration>
    </>
  );
};

export async function getServerSideProps({
  query,
  locale,
}: {
  query: FilterGetParams;
  locale: string;
}) {
  const queryClient = new QueryClient();
  await queryClient.prefetchQuery(
    queryKeys.leaderboardsFilters(),
    getLeaderboardsFilters
  );
  return {
    props: {
      query,
      dehydratedState: dehydrate(queryClient),
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default Leaderboards;
